<div class="plugin-wrapper share-feedback">
    <core-layout-error-not-found [hidden]="status != NOT_FOUND"></core-layout-error-not-found>
    <div class="loader plugin-section" [hidden]="status != LOADING">
      <div class="dimmed_outset">
          <core-title-section [title]="'FEEDBACK OVERVIEW'"></core-title-section>
      </div>
      <div class="dimmed dimmed_main">
          <div class="dimmed_content">
              <div class="dimmed_flex">
                  <span class="dimmed_tag"></span>
                  <span class="dimmed_tag"></span>
                  <span class="dimmed_tag"></span>
              </div>
          </div>
      </div>
      <!-- <core-helpers-box-loading [hidden]="status != LOADING"></core-helpers-box-loading> -->
  </div>
    
    <nav *ngIf="status == DONE" class="tab_navigation">
      <!-- <plugin-share-feedback-core-versions-thumbnail-vertical-list>-->
      <plugin-share-feedback-core-versions-thumbnail-vertical-list
        [feedbacks]="feedbacks" [versionSelected]="feedbackSelected.version" [seeApprovalStatus]='false' (clickVersion)="onClickVersion($event)"
      ></plugin-share-feedback-core-versions-thumbnail-vertical-list>
    </nav>


    <section class="main-content share-feedback-review">
      <plugin-share-feedback-feedback-review *ngIf="feedbackSelected != null" [feedback]="feedbackSelected"></plugin-share-feedback-feedback-review>
    </section>
</div>
